import type { LandingInfraContent, LandingWhyContent } from "../types";

export const landingWhy: LandingWhyContent = {
  title: {
    line1: "Für Trader gebaut.",
    line2Lead: "Gebaut, um ",
    line2Highlight: "finanziert zu bleiben",
    line2Tail: ".",
  },
  // [de-review] Positions Flex Fund against competitors. A claim about how other
  // prop firms operate, so the wording is commercially load-bearing.
  sub: "Die meisten Prop-Firmen sind darauf ausgelegt, Trader hinauszudrängen. Unsere ist darauf ausgelegt, sie im Markt zu halten — über Jahre statt Wochen.",
  split: {
    eyebrow: "Profit-Split",
    baseSplitLabel: "BASIS-SPLIT",
    // [de-review] The central pricing claim: 80% base, 90% via a paid add-on.
    body: "Jedes Konto startet mit einem 80-%-Split. Upgrade auf 90 % über das optionale Add-on beim Checkout. Ein Hebel, fest für die gesamte Laufzeit des Kontos.",
    yourShare: "DEIN ANTEIL",
    baseChipLabel: "BASIS",
    addOnChipLabel: "MIT ADD-ON",
  },
  payouts: {
    pill: "SCHNELL",
    title: "Auszahlungen auf Abruf.",
    body: "Bank, USDC/USDT oder Karte. Warteschlangenposition in Echtzeit im Dashboard.",
    // "USDC" is a token ticker and "BANK" is spelled identically in German;
    // only "CARD" actually changes. Left explicit rather than derived so the
    // untranslated two are a visible decision instead of an oversight.
    methods: { usdc: "USDC", card: "KARTE", bank: "BANK" },
  },
  execution: {
    eyebrow: "Ausführung",
    title: "Institutionelle Ausführung.",
    body: "Live MetaTrader 5 mit Raw Spreads, tiefer Liquidität und konstanten Fills.",
    // German uses a decimal COMMA and a space before the unit. "0,1" is the
    // correct localisation of "0.1", not an altered figure.
    latency: "12 ms Median",
    spread: "0,1 Pip Ø",
  },
  scaling: {
    pill: "SKALIERUNG",
    title: "Konto skalieren.",
    // [de-review] States the maximum allocation — a commercial claim.
    body: "Dokumentierte Wachstumsstufen bis zu einer Allokation von 1 Mio. $. Gleiche Risikostruktur, größere Zahlen.",
    upToPrefix: "bis zu",
    milestonePath: "Meilenstein-Pfad",
  },
  evalLive: {
    eyebrow: "Gleiche Regeln",
    title: "Evaluation = Live.",
    // [de-review] A promise about rule parity between evaluation and funded
    // trading — the claim most likely to be held against the firm.
    body: "Was in der Evaluation gehandelt wird, wird genauso im finanzierten Konto gehandelt. Keine Überraschungsregeln auf der Zielgeraden.",
    evalPill: "EVAL",
    livePill: "LIVE",
    rules: {
      profitTarget: "Gewinnziel",
      dailyLoss: "Tagesverlust",
      maxDd: "Max. DD",
      leverage: "Hebel",
    },
  },
};

export const landingInfra: LandingInfraContent = {
  title: { line1: "Echte Märkte.", line2Highlight: "Echte Ausführung." },
  sub: "STP-Ausführung, Tier-1-Bankliquidität und MetaTrader 5. Dieselbe Infrastruktur, auf die professionelle Desks setzen.",
  cards: {
    stpRouting: {
      eyebrow: "AUSFÜHRUNG",
      // "STP" is an industry acronym (Straight Through Processing) and is used
      // untranslated in German trading copy.
      title: "STP-Routing",
      body: "Orders werden ohne Dealing-Desk-Eingriff direkt an den Markt geleitet. Spreads und Ausführung spiegeln jederzeit reale Marktbedingungen wider.",
    },
    tier1Banks: {
      eyebrow: "LIQUIDITÄT",
      title: "Tier-1-Banken",
      body: "Gestützt auf erstklassige institutionelle Liquiditätsanbieter. Dieselben Desks, die institutionellen Flow in professionellen Handelsräumen ausführen.",
    },
    metaTrader5: {
      eyebrow: "PLATTFORM",
      // PROPER NOUN — the product name. Never translated.
      title: "MetaTrader 5",
      body: "Branchenstandard für Ausführung und Analyse. Algo-Trading, Markttiefe, Multi-Instrument. Die Plattform, die professionelle Desks nutzen.",
    },
  },
};
